import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, map } from "rxjs";
import { environment } from "../../../environments/environment";
import { CreatePollRequest, PollResponse, PollResultsResponse, UpdatePollRequest } from "../models/poll.model";
import { PollId, stripPrefix } from "../../shared/models/entity.model";

// Backend response omits the `type` discriminator (the endpoint implies it). We tag it
// client-side so a fetched Poll can participate in `Poll | Freeform` narrowing.
type PollResponseBody = Omit<PollResponse, "type">;

@Injectable({ providedIn: "root" })
export class PollApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = `${environment.interactiveExperienceServiceUrl}/v1/interactives/poll`;

    get(id: PollId): Observable<PollResponse> {
        return this.http
            .get<PollResponseBody>(`${this.baseUrl}/${stripPrefix(id)}`)
            .pipe(map(response => ({ ...response, type: "poll" })));
    }

    create(request: CreatePollRequest): Observable<PollResponse> {
        return this.http
            .post<PollResponseBody>(this.baseUrl, request)
            .pipe(map(response => ({ ...response, type: "poll" })));
    }

    update(id: string, request: UpdatePollRequest): Observable<PollResponse> {
        return this.http
            .patch<PollResponseBody>(`${this.baseUrl}/${id}`, request)
            .pipe(map(response => ({ ...response, type: "poll" })));
    }

    delete(id: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`);
    }

    getResults(id: string): Observable<PollResultsResponse> {
        return this.http.get<PollResultsResponse>(`${this.baseUrl}/${id}/results`);
    }
}
